/*
 * @Author: bianbinbin
 * @LastEditors: bianbinbin
 * @LastEditTime: 2026-05-20 13:04:57
 * @PageTitle: 页面...
 */

const eventLibrary = r =>
  require.ensure([], () => r(require('@/views/eventLibrary/eventLibrary.vue'), 'eventLibrary'))
const eventStatistics = r =>
  require.ensure([], () => r(require('@/views/eventLibrary/eventStatistics.vue'), 'eventStatistics'))
const router = [
  {
    path: '/eventLibrary',
    name: 'eventLibrary',
    meta: {
      title: '运行事件库'
    },
    component: eventLibrary
  },
  {
    path: '/eventStatistics',
    name: 'eventStatistics',
    meta: {
      title: '运行事件统计'
    },
    component: eventStatistics
  }
]

export default router
